<template>
  <v-img
    :class="className"
    :src="require('../../assets/'+imageName)"
    :contain="contain"
    :position="position"
  />
</template>

<script>
export default {
  name: 'LogoImage',
  props: {
    position: {
      type: String,
      default: 'left center',
    },
    contain: {
      type: Boolean,
      default: true,
    },
    className: {
      type: String,
      default: 'header-logo',
    },
    imageName: {
      type: String,
      default: 'logo.png',
    },
  },

}
</script>

<style  scoped>
.header-logo-resize >>> .v-image__image--cover {
    background-size: auto !important;
}

.header-logo {
    max-height:55%;
    margin-left: 30px;
}
</style>
